import $ from 'jquery';
import ko from 'knockout';

/**
 * Binding to display an element by fading it in
 * @example
 * <p data-bind="fadeIn: ko.observable(true)"></p>
 */
ko.bindingHandlers.fadeIn = {

  update: function (element, valueAccessor) {

    var value = ko.utils.unwrapObservable(valueAccessor());

    if (value) {
      $(element).fadeIn();
    }
  }
};
